import ClipboardJS from 'clipboard'

class CopyLink {
    constructor() {
        this.copyUrl = null;
        this.$copyUrl = null;

        this['jQueryInit']();
    }

    /**
     * Initialize all objects used in UserBooking class
     */
    ['jQueryInit']() {
        let _this = this;

        (function ($) {

            $(document).ready(() => {

                _this.$copyUrl = $('.opf_copyLink');

                _this['appInit']($);

            });

        })(jQuery);
    }

    /**
     * JS functionality
     *
     * @param {jQuery} $
     */
    ['appInit']($) {
        let _this = this;

        _this.copyUrl = new ClipboardJS('.opf_copyLink');

        _this.$copyUrl
            .click((e) => {
                e.preventDefault();
            })
        ;
    }
}

export default CopyLink;